export const REMINDER_REASONS = {
  'BIRTHDAY': 'BIRTHDAY',
  'JUBILEE': 'JUBILEE'
};
